import React from 'react'

import FormField from './FormField'

export const FORM_MODES = {
  CREATE: 1,
  EDIT: 2,
}

const Form = ({ item, fields, onChange }) => {
  const onFieldChange = (fieldName) => (value) =>
    onChange({ ...item, [fieldName]: value })

  return (
    <>
      {fields.map((field, i) => (
        <FormField item={item} field={field} onChange={onFieldChange} key={i} />
      ))}
    </>
  )
}

export default Form
